import { render, staticRenderFns } from "./SkeletonBoxes.vue?vue&type=template&id=cd6ad6a6&"
import script from "./SkeletonBoxes.vue?vue&type=script&lang=js&"
export * from "./SkeletonBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports